import { FunctionComponent, useCallback } from "react";

interface ImageProps {
  src?: string | null;
  alt?: string;
  fallbackUrl?: string;
}

const DEFAULT_FALLBACK_URL = "/images/default_cover_photo.png";

const Image: FunctionComponent<ImageProps> = ({ src, alt, fallbackUrl }) => {
  const handleImageError = useCallback(
    (event: React.SyntheticEvent<HTMLImageElement>) => {
      event.currentTarget.src = fallbackUrl ?? DEFAULT_FALLBACK_URL;
    },
    [fallbackUrl],
  );

  return (
    <img
      src={src ?? DEFAULT_FALLBACK_URL}
      alt={alt}
      onError={handleImageError}
    />
  );
};

export { Image };
